/* global angular _ */
import { defaultColors } from '@prolaera/library';
import { keyBy, orderBy } from 'lodash';

export default function($log, $stateParams, $q, $filter, ApiClass, RegulatorClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.certsHeaders = [
    { title: 'Date Issued', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2', default: 'reverse' },
    { title: 'Certificate Name', class: 'col-lg-4 col-md-4 col-sm-4 col-xs-4' },
    { title: 'Subject Area', class: 'col-lg-3 col-md-3 col-sm-3 col-xs-3' },
    { title: 'Credits', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' },
    { title: 'Delivery Method', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' }
  ];

  vm.setActive = (regulatorKey, yearIndex = 0, categoryIndex = 0) => {
    if (!vm.activeTab) {
      regulatorKey = Object.keys(vm.flatCompObj).sort()[0];
      vm.activeTab = regulatorKey;
    }
    vm.activeYearIndex = yearIndex;
    vm.activeCompliance = vm.flatCompObj[regulatorKey][yearIndex];
    vm.activeGauge = vm.activeCompliance.gauges[categoryIndex];
  };

  function activate() {
    $log.debug('Compliance Overview Component Activated');
    vm.loaded = false;
    vm.error = {};
    vm.profileUid = $stateParams.employeeID || $stateParams.id;
    vm.licenseObj = {};
    vm.licenseActiveArr = [];

    const qArr = [
      RegulatorClass.loadRegulators(),
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:flatcompliance': true,
            'include:certificates': true
          }
        }
      )
    ];

    $q.all(qArr)
      .then(([{ arr: regulators, obj: regulatorsDict }, { data: { certificates, flatcompliance } }]) => {
        $log.debug('Compliance Overview Component Data', arguments);

        vm.flatComp = !!flatcompliance.length;
        vm.certs = certificates;
        vm.certsDict = _.keyBy(certificates, 'cert_id');

        vm.gaugesDict = Object.assign([], regulators).reduce((obj, regulator) => {
          if (!obj.hasOwnProperty(regulator.reg_id)) obj[regulator.reg_id] = {};
          if (!obj[regulator.reg_id].hasOwnProperty('basic_name'))
            obj[regulator.reg_id].basic_name = regulator.basic_name;
          obj[regulator.reg_id][regulator.date] = keyBy(regulator.gauges, 'value');
          return obj;
        }, {});

        vm.regulatorTimeDict = regulatorsDict;

        vm.flatCompObj = flatcompliance.reduce((obj, item) => {
          if (!obj[item.reg_id]) obj[item.reg_id] = [];
          if (item.cycle_date) item.sortTime = new Date(item.cycle_date).getTime();
          obj[item.reg_id] = orderBy([...obj[item.reg_id], item], ['sortTime'], ['desc']);
          obj[item.reg_id].name = vm.regulatorTimeDict[item.reg_id].basic_name;
          obj[item.reg_id].key = item.reg_id;
          return obj;
        }, {});

        //This should be backend functioniliaty
        if (!Object.keys(vm.flatCompObj).length) return (vm.loaded = true);
        Object.keys(vm.flatCompObj).forEach(key => {
          vm.flatCompObj[key]
            .map(comp => {
              const { cycle_limiter, cycle_total, cycle } = regulatorsDict[comp.reg_id][comp.reg_date];

              if (!('cycle_limiter' in comp)) comp.cycle_limiter = cycle_limiter;
              if ('cycle' in comp.cycle_limiter) comp.cycle = comp.cycle_limiter.cycle;
              if ('prorate_cycle' in comp.cycle_limiter) comp.cycle = comp.cycle_limiter.prorate_cycle;
              if (!('cycle' in comp)) comp.cycle = cycle;
              if (!('cycle_total' in comp.cycle_limiter)) comp.cycle_limiter.cycle_total = cycle_total;

              return comp;
            })
            .forEach(complianceObj => {
              let remaining = complianceObj.cycle_limiter.cycle_total - complianceObj.applied.total;
              remaining = remaining > 0 ? remaining : 0;
              complianceObj.dial = [
                {
                  color: defaultColors['remaining'],
                  label: 'Total Remaining',
                  value: $filter('number')(remaining, 2)
                }
              ];

              const tempGauges = vm.gaugesDict[complianceObj.reg_id][complianceObj.reg_date];

              complianceObj.gauges = [];

              for (const key in tempGauges) {
                if (tempGauges.hasOwnProperty(key)) {
                  const gaugeTemp = angular.copy(tempGauges[key]);
                  gaugeTemp.show_min = false;

                  let value = complianceObj.applied[key] || 0;

                  if (
                    complianceObj.cycle_limiter &&
                    complianceObj.cycle_limiter.min &&
                    key in complianceObj.cycle_limiter.min
                  ) {
                    gaugeTemp.max = complianceObj.cycle_limiter.min[key];
                    gaugeTemp.show_min = true;
                  }

                  if (
                    tempGauges[key].span &&
                    'span' in complianceObj &&
                    key in complianceObj.span &&
                    'total' in complianceObj.span[key]
                  ) {
                    value = complianceObj.span[key].total;
                    gaugeTemp.show_min = true;
                  }

                  if (
                    tempGauges[key].span_count &&
                    'span_count' in complianceObj &&
                    key in complianceObj.span_count &&
                    'total' in complianceObj.span_count[key]
                  ) {
                    value = complianceObj.span_count[key].total;
                    gaugeTemp.show_min = true;
                  }

                  gaugeTemp.hoursEarned = value;

                  complianceObj.dial.push({
                    color: defaultColors[gaugeTemp.color || $filter('CategoryColor')(gaugeTemp.name)],
                    label: gaugeTemp.name,
                    value
                  });
                  complianceObj.gauges.push(gaugeTemp);
                }
              }
            });
        });
        vm.setActive();
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/complianceOverview/controller.js